import { onMounted, watch, ref } from "vue";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";
import { useStore } from "vuex";

export function setupConfiguracao() {
  const store = useStore();

  const catalogoUuid = salvarCatalogoUuid();
  const dadoSetupAutenticacao = ref([]);

  const verificarSetupConfiguracao = async () => {
    if (
      catalogoUuid.catalogoUuid.value == null ||
      catalogoUuid.catalogoUuid.value == undefined
    ) {
      return;
    }
    try {
      const response = await store.dispatch(
        "ferramentaria/configuracaoCatalogo",
        {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
        }
      );
      if (response.data.resultado.dados.length > 0) {
        dadoSetupAutenticacao.value = response.data.resultado.dados;
      }
    } catch (error) {
      console.log(error);
    }
  };

  watch(
    () => catalogoUuid.catalogoUuid.value,
    () => {
      verificarSetupConfiguracao();
    }
  );

  onMounted(() => {
    verificarSetupConfiguracao();
  });

  return {
    dadoSetupAutenticacao,
  };
}
